/* eslint-disable no-nested-ternary */
import { useRouter } from '@application/utils';
import type { AnimalTypeEnum } from '@gql/graphql';
import { useMemo } from 'react';

export interface BookingPageSearchValues {
  proUrl: string;
  workerId: number;
  workerServiceId: number;
  bookingStart: string;
  animalType?: AnimalTypeEnum;
  breedId?: number;
  forMultiAnimals?: boolean;
}

export const useSearch = () => {
  const { infoFromCurrentPath } = useRouter();

  const valuesFromSearch = useMemo((): BookingPageSearchValues | undefined => {
    const {
      proUrl,
      workerId,
      workerServiceId,
      bookingStart,
      animalType,
      breedId,
      forMultiAnimals,
    } = infoFromCurrentPath.search;

    if (
      !proUrl ||
      !workerId ||
      !workerServiceId ||
      !bookingStart ||
      typeof proUrl !== 'string' ||
      typeof bookingStart !== 'string'
    ) {
      return;
    }

    return {
      proUrl,
      workerId: Number(workerId),
      workerServiceId: Number(workerServiceId),
      bookingStart,
      animalType: animalType as AnimalTypeEnum | undefined,
      breedId: breedId ? Number(breedId) : undefined,
      forMultiAnimals:
        forMultiAnimals === 'true' ? true : forMultiAnimals === 'false' ? false : undefined,
    };
  }, [infoFromCurrentPath.search]);

  return { valuesFromSearch };
};
